var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 17.1655C1 14.7175 3.02522 12.7329 5.52346 12.7329H22.6099C25.1081 12.7329 27.1333 14.7175 27.1333 17.1655V28.567C27.1333 31.015 25.1081 32.9996 22.6099 32.9996H5.52345C3.02521 32.9996 1 31.015 1 28.567V17.1655ZM5.52346 13.8411C3.64978 13.8411 2.13086 15.3295 2.13086 17.1655V28.567C2.13086 30.403 3.64978 31.8914 5.52345 31.8914H22.6099C24.4836 31.8914 26.0025 30.403 26.0025 28.567V17.1655C26.0025 15.3295 24.4836 13.8411 22.6099 13.8411H5.52346Z",
    fill: "#F59D0E",
    stroke: "#F59D0E",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0674 19.1927C12.8628 19.1927 11.8862 20.206 11.8862 21.4559C11.8862 22.3119 12.344 23.0577 13.022 23.4428L13.3041 23.6031V26.2815C13.3041 26.7189 13.6458 27.0735 14.0674 27.0735C14.489 27.0735 14.8307 26.7189 14.8307 26.2815V23.6075L15.1597 23.4155C15.812 23.023 16.2487 22.292 16.2487 21.4559C16.2487 20.206 15.2721 19.1927 14.0674 19.1927ZM10.8008 21.4559C10.8008 19.5839 12.2633 18.0664 14.0674 18.0664C15.8716 18.0664 17.3341 19.5839 17.3341 21.4559C17.3341 22.6166 16.7716 23.6403 15.9162 24.2507V26.2815C15.9162 27.3409 15.0884 28.1997 14.0674 28.1997C13.0464 28.1997 12.2186 27.3409 12.2186 26.2815V24.2506C11.3631 23.6402 10.8008 22.6165 10.8008 21.4559Z",
    fill: "#F59D0E",
    stroke: "#F59D0E",
    strokeWidth: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0685 2.09296C11.0764 2.09296 8.65089 4.469 8.65089 7.4V13.2535C8.65089 13.5553 8.40112 13.8 8.09302 13.8C7.78492 13.8 7.53516 13.5553 7.53516 13.2535V7.4C7.53516 3.86538 10.4602 1 14.0685 1C17.6768 1 20.6018 3.86538 20.6018 7.4V13.8H19.4861V7.4C19.4861 4.469 17.0605 2.09296 14.0685 2.09296Z",
    fill: "#F59D0E",
    stroke: "#F59D0E",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.ef514ee4a250995e7b23ce9abfc1651a.svg";
export { ForwardRef as ReactComponent };